import { startCase } from 'lodash'
import { User } from 'lucide-react'

import { formatTimestamp } from '@helpers/format'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { countries } from '@components/PhoneNumber'

const Item = ({ label, value }) => (
  <div className='px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
    <dt className='font-medium text-gray-900 dark:text-gray-100'>{label}</dt>
    <dd className='mt-1 leading-6 text-gray-700 dark:text-gray-300 sm:col-span-2 sm:mt-0'>{value}</dd>
  </div>
)

const ProfileDetailsCard = ({ profile, isImpersonating, handleImpersonateUser }) => {
  const dialCode = countries.find(country => country.code === profile.phoneCountryCode)?.dialCode

  return (
    <Card className='w-auto mb-5'>
      <CardHeader className='flex flex-row justify-between items-center'>
        <CardTitle className='text-2xl'>{profile.fullName}</CardTitle>
        <Button
          onClick={() => handleImpersonateUser(profile.user?.id)}
          disabled={isImpersonating || !profile.allowSupportAccess}
          variant='outline'
        >
          <User className="w-5 h-5 mr-2" />
          {isImpersonating ? 'Impersonating...' : 'Impersonate'}
        </Button>
      </CardHeader>
      <CardContent>
        <div className='border-t border-gray-100 dark:border-gray-700'>
          <dl className='divide-y divide-gray-100 dark:divide-gray-700'>
            <Item
              label='Email'
              value={profile.email}
            />
            <Item
              label='Phone number'
              value={profile.phoneNumber ? `${dialCode} ${profile.phoneNumber}` : 'N/A'}
            />
            <Item
              label='Organization role'
              value={profile.organizationRole ? startCase(profile.organizationRole) : 'N/A'}
            />
            <Item
              label='Trial started at'
              value={profile.trialStartedAt ? formatTimestamp(profile.trialStartedAt) : 'N/A'}
            />
            <Item
              label='Trial length'
              value={profile.trialLength ? `${profile.trialLength} days` : 'N/A'}
            />
            <Item
              label='Allow support access'
              value={profile.allowSupportAccess ? 'Yes, can impersonate' : 'No, cannot impersonate'}
            />
          </dl>
        </div>
      </CardContent>
    </Card>
  )
}

export default ProfileDetailsCard 
